/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmployeeLeaveSettingsImport
 */
export interface EmployeeLeaveSettingsImport {
    /**
     * 
     * @type {number}
     * @memberof EmployeeLeaveSettingsImport
     */
    companyId: number;
    /**
     * 
     * @type {number}
     * @memberof EmployeeLeaveSettingsImport
     */
    uploadId: number | null;
    /**
     * 
     * @type {number}
     * @memberof EmployeeLeaveSettingsImport
     */
    initiatedBy: number;
    /**
     * 
     * @type {number}
     * @memberof EmployeeLeaveSettingsImport
     */
    employeeCount: number;
    /**
     * 
     * @type {string}
     * @memberof EmployeeLeaveSettingsImport
     */
    status: string;
}

/**
 * Check if a given object implements the EmployeeLeaveSettingsImport interface.
 */
export function instanceOfEmployeeLeaveSettingsImport(value: object): value is EmployeeLeaveSettingsImport {
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('uploadId' in value) || value['uploadId'] === undefined) return false;
    if (!('initiatedBy' in value) || value['initiatedBy'] === undefined) return false;
    if (!('employeeCount' in value) || value['employeeCount'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function EmployeeLeaveSettingsImportFromJSON(json: any): EmployeeLeaveSettingsImport {
    return EmployeeLeaveSettingsImportFromJSONTyped(json, false);
}

export function EmployeeLeaveSettingsImportFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmployeeLeaveSettingsImport {
    if (json == null) {
        return json;
    }
    return {
        
        'companyId': json['companyId'],
        'uploadId': json['uploadId'],
        'initiatedBy': json['initiatedBy'],
        'employeeCount': json['employeeCount'],
        'status': json['status'],
    };
}

  export function EmployeeLeaveSettingsImportToJSON(json: any): EmployeeLeaveSettingsImport {
      return EmployeeLeaveSettingsImportToJSONTyped(json, false);
  }

  export function EmployeeLeaveSettingsImportToJSONTyped(value?: EmployeeLeaveSettingsImport | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'companyId': value['companyId'],
        'uploadId': value['uploadId'],
        'initiatedBy': value['initiatedBy'],
        'employeeCount': value['employeeCount'],
        'status': value['status'],
    };
}

